
export const mapValues = (values)=>{
    if(typeof values === typeof []){
        return values.map(item=>{
            if(item.timestamp){
                item.timestamp = item.timestamp.split(".")[0];
            }
            return item;
        })
    }
    return  false
}